import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ProductService} from '../../../resources/services/product.service';
import {ValidateService} from '../../../resources/modules/validate/validate.service';
import {ToastrService} from 'ngx-toastr';
import {FormService} from '../../../resources/services/form.service';
import {MessageService} from '../../../resources/services/message.service';
import {FormEntityExtension} from '../../../resources/extensions/form-entity-extension/form-entity.extension';
import {FormEntityExtensionService} from "../../../resources/extensions/form-entity-extension/form-entity-extension.service";
import { UrlService } from 'src/app/resources/services/url.service';
import {MimeTypeConfig} from "../../../configs/mime-type.config";

@Component({
  selector: 'store-version-form',
  templateUrl: './store-version-form.component.html',
})
export class StoreVersionFormComponent extends FormEntityExtension implements OnInit {

  @Input() edit: boolean = false;

  storeDropzoneConfig: any = {
    acceptedFiles: MimeTypeConfig.zip,
    params: {},
  };
  acceptedFiles: string = MimeTypeConfig.zip;
  storeDropzoneAppleConfig: any;
  storeDropzoneGoogleConfig: any;

  /**
   * отдельно от Extension,
   * чтобы конифг для ропзона использовать
   * @param value
   */
  @Input('data') set data$(value) {
    if (value) {
      this.data = value;
      this.storeDropzoneAppleConfig.params.storeVersionId = this.data?.id;
      this.storeDropzoneGoogleConfig.params.storeVersionId = this.data?.id;
      this.setControls();
    }
    this.patchValue();
  }


  constructor(protected formEntityExtensionService: FormEntityExtensionService,
              private urlService: UrlService) {
    super(formEntityExtensionService);
    this.storeDropzoneConfig.url = this.urlService.uploadAddressable();
    this.storeDropzoneAppleConfig = Object.assign({}, this.storeDropzoneConfig, {params: {platform: 'apple'}});
    this.storeDropzoneGoogleConfig = Object.assign({}, this.storeDropzoneConfig,{params: {platform: 'google'}});
  }

  ngOnInit(): void {
    this.initForm(
      new FormBuilder().group({
        version: ['', Validators.required],
        store: [null, Validators.required],
        isDeprecated: [false],
        supported: [null]
        // active: [false],
      })
    );
  }

  setControls() {

    this.form.addControl('appleAddressable', new FormControl());
    this.form.addControl('googleAddressable', new FormControl());

  }

  ngAfterViewInit() {

  }

}
